import type { SVGIconProps } from '../types';
import styles from './Check.module.css';

export function AnimatedCheck({
    className,
    size,
    isSelected = false,
}: SVGIconProps & { isSelected: boolean }) {
    const svgStyle = {
        verticalAlign: 'middle',
        width: size ?? '1em',
        height: size ?? '1em',
    };

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 16 16"
            className={`${className} ${isSelected ? styles.tickVisible : styles.tickHidden}`}
            style={svgStyle}
        >
            <path
                d="M3 8L6.5 12L13 4"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className={styles.tickPath}
            />
        </svg>
    );
}
